import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = icon;

  if (!IconComponent && name) {
    try {
      if (name.startsWith('Fi')) IconComponent = FiIcons[name];
      else if (name.startsWith('Fa')) IconComponent = FaIcons[name];
      else if (name.startsWith('Si')) IconComponent = SiIcons[name];
    } catch (e) {
      IconComponent = null;
    }
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;